export class FueFolletMetadata {
    startingPlace: string;
    endingPlace: string;
    startingDialog?: string;
    endingDialog?: string;
    encounteredPrerequisite?: string;
    tokenPrerequisite?: string;
    animation?: string;
    scale?: number;
    xOffset?: number = 0;
    yOffset?: number = 0;
    finalDestination?: boolean = false;
    hidden?: boolean = false;
    hideOnMap?: boolean = false;
}

export const FueFolletList: Array<FueFolletMetadata> = [
    {
        startingPlace: "Brandt Hall",
        endingPlace: "VCU Engineering Building",
        // tokenPrerequisite: "Brandt Hall",
        animation: "Jessie_idle",
        scale: 2.5,
        yOffset: 50,
    },
    {
        startingPlace: "VCU Engineering Building",
        endingPlace: "Rest in Pieces",
        tokenPrerequisite: "Spoke with Klein",
        yOffset: 50,
    },
    {
        startingPlace: "Rest in Pieces",
        endingPlace: "Hollywood Cemetery",
        tokenPrerequisite: "Rest in Pieces",
    },
    {
        startingPlace: "Hollywood Cemetery",
        endingPlace: "James Monroe's Grave",
        tokenPrerequisite: "Rest in Pieces",
        hidden: true,
        hideOnMap: true,
    },
    {
        startingPlace: "James Monroe's Grave",
        endingPlace: "Pump House",
        tokenPrerequisite: "James Monroe's Grave",
    },
    // Japanese Gardens, find Grotto
    // {
    //     startingPlace: "Foushee's Mill",
    //     endingPlace: "Pump House",
    // },
    {
        startingPlace: "Pump House",
        endingPlace: "Belle Isle Gym",
        tokenPrerequisite: "Pump House"
    },
    {
        startingPlace: "Belle Isle Gym",
        endingPlace: "Belle Isle Power Plant",
        tokenPrerequisite: "Pump House",
        hidden: true,
        hideOnMap: true,
    },
    {
        startingPlace: "Belle Isle Power Plant",
        endingPlace: "Pratt's Castle",
        tokenPrerequisite: "Belle Isle Power Plant",
        xOffset: 300,
    },    
    {
        startingPlace: "Pratt's Castle",
        endingPlace: "Monumental Church",
        tokenPrerequisite: "Pratt's Castle"
    },
    {
        startingPlace: "Monumental Church",
        endingPlace: "Poe Museum",
        tokenPrerequisite: "Monumental Church",
        xOffset: -300,
    },
    {
        startingPlace: "Poe Museum",
        endingPlace: "Church Hill",
        tokenPrerequisite: "Poe Museum",
         xOffset: 300,
    },
    {
        startingPlace: "Church Hill",
        endingPlace: "Richmond Vampire",
        tokenPrerequisite: "Church Hill",
        animation: "gouhl_run",
    },
    {
        startingPlace: "Richmond Vampire",
        endingPlace: "VCU Engineering Building",
        tokenPrerequisite: "Richmond Vampire",
        finalDestination: true,
    },
]